/* app/onboarding/tourPin.js — пространство, где тур начался (kitchen-ux A2 круг 5, S10).

   Демо-сущности тура создаются в пространстве вкладки, а завершение (бэк их удаляет) уходит
   закреплённым заголовком туда же, даже если вкладку за время тура переключили.
   Закрепление — первое ИЗВЕСТНОЕ пространство тура: после входа тур стартует через 400 мс и
   может обогнать список пространств — пустое закрепление ({}) дозаписывается, как только
   пространство появилось. Тур закончился — закрепление сброшено: следующий тур — заново. */

/* prev — прежнее закрепление | null; active — тур идёт; pinNow — () => опции запроса
   ({ headers } | {}: pinWorkspace из lib/api/client.js) → новое закрепление | null. */
export function nextTourPin(prev, active, pinNow) {
  if (!active) return null;
  if (prev && prev.headers) return prev;
  return pinNow();
}
